module.exports = __webpack_public_path__ + "img/oneOrange.02393b44.jpg";